import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";

const LOGO_CHOCO = "https://customer-assets.emergentagent.com/job_6fa72c44-1c40-4a4f-af1b-3eb11820d1a2/artifacts/gxcr3jm2_Logo%20chocolat.png";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      style={{ backgroundColor: "#3D1602", color: "#F7F3EA", padding: "80px 24px 48px" }}
    >
      <div style={{ maxWidth: "1400px", margin: "0 auto" }}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr", gap: "48px", marginBottom: "64px", alignItems: "start" }}
          className="md:grid-cols-3">

          {/* Logo + tagline */}
          <div>
            <img src={LOGO_CHOCO} alt="ELLAA WEDDING" style={{ height: "150px", marginBottom: "20px", opacity: 1, filter: "brightness(0) saturate(100%) invert(97%) sepia(5%) saturate(400%) hue-rotate(330deg) brightness(98%) contrast(93%)" }} />
            <p style={{ fontFamily: "'Noto Serif Ethiopic', Georgia, serif", fontStyle: "italic", fontSize: "20px", color: "rgba(247,243,234,0.6)", marginBottom: "16px", lineHeight: 1.4 }}>
              L'amour orchestré avec précision.
            </p>
            <p style={{ fontSize: "12px", lineHeight: "1.8", color: "rgba(247,243,234,0.5)", fontWeight: 300, letterSpacing: "0.5px" }}>
              Wedding planner spécialisée dans les mariages<br />afro-caribéens et multiculturels élégants.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <p style={{ fontSize: "10px", letterSpacing: "4px", textTransform: "uppercase", marginBottom: "24px", color: "rgba(247,243,234,0.4)" }}>Navigation</p>
            <div style={{ display: "flex", flexDirection: "column", gap: "14px" }}>
              {[
                { label: "À Propos", path: "/a-propos" },
                { label: "Prestations", path: "/prestations" },
                { label: "Galerie", path: "/galerie" },
                { label: "Blog", path: "/blog" },
                { label: "Contact", path: "/contact" },
              ].map((link) => (
                <Link key={link.path} to={link.path}
                  style={{ fontSize: "13px", color: "rgba(247,243,234,0.6)", textDecoration: "none", fontWeight: 300, transition: "color 0.3s ease", letterSpacing: "0.5px" }}
                  onMouseEnter={e => e.target.style.color = "#F7F3EA"}
                  onMouseLeave={e => e.target.style.color = "rgba(247,243,234,0.6)"}
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Contact + Social */}
          <div>
            <p style={{ fontSize: "10px", letterSpacing: "4px", textTransform: "uppercase", marginBottom: "24px", color: "rgba(247,243,234,0.4)" }}>Contact</p>
            <div style={{ display: "flex", flexDirection: "column", gap: "12px", marginBottom: "32px" }}>
              <a href="mailto:ellaa.wedding@gmail.com"
                style={{ fontSize: "13px", color: "rgba(247,243,234,0.6)", textDecoration: "none", fontWeight: 300, transition: "color 0.3s ease" }}
                onMouseEnter={e => e.target.style.color = "#F7F3EA"}
                onMouseLeave={e => e.target.style.color = "rgba(247,243,234,0.6)"}
              >ellaa.wedding@gmail.com</a>
              <a href="https://api.whatsapp.com/send?phone=33783600328" target="_blank" rel="noopener noreferrer"
                style={{ fontSize: "13px", color: "rgba(247,243,234,0.6)", textDecoration: "none", fontWeight: 300, transition: "color 0.3s ease" }}
                onMouseEnter={e => e.target.style.color = "#F7F3EA"}
                onMouseLeave={e => e.target.style.color = "rgba(247,243,234,0.6)"}
              >+33 7 83 60 03 28</a>
            </div>
            <a href="https://www.instagram.com/ellaa.wedding?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank" rel="noopener noreferrer"
              data-testid="footer-instagram"
              style={{ display: "inline-flex", alignItems: "center", gap: "10px", fontSize: "11px", letterSpacing: "3px", textTransform: "uppercase", color: "rgba(247,243,234,0.6)", textDecoration: "none", border: "1px solid rgba(247,243,234,0.2)", padding: "10px 20px", transition: "all 0.3s ease" }}
              onMouseEnter={e => { e.currentTarget.style.color = "#F7F3EA"; e.currentTarget.style.borderColor = "rgba(247,243,234,0.5)"; }}
              onMouseLeave={e => { e.currentTarget.style.color = "rgba(247,243,234,0.6)"; e.currentTarget.style.borderColor = "rgba(247,243,234,0.2)"; }}
            >
              <Instagram size={14} />@ellaa.wedding
            </a>
          </div>
        </div>

        {/* Bottom bar */}
        <div style={{ borderTop: "1px solid rgba(247,243,234,0.1)", paddingTop: "32px", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "16px" }}>
          <p style={{ fontSize: "11px", color: "rgba(247,243,234,0.35)", letterSpacing: "1px" }}>
            © {new Date().getFullYear()} ELLAA WEDDING — Tous droits réservés
          </p>
          <div style={{ display: "flex", gap: "24px", alignItems: "center" }}>
            <Link to="/cgv" style={{ fontSize: "10px", color: "rgba(247,243,234,0.35)", textDecoration: "none", letterSpacing: "2px", transition: "color 0.3s ease" }}
              onMouseEnter={e => e.target.style.color = "rgba(247,243,234,0.7)"}
              onMouseLeave={e => e.target.style.color = "rgba(247,243,234,0.35)"}
            >CGV</Link>
            <Link to="/admin" style={{ fontSize: "10px", color: "rgba(247,243,234,0.2)", textDecoration: "none", letterSpacing: "2px" }}>Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
